import React, {Fragment, useContext, useEffect, useState} from 'react';
import { Container } from 'semantic-ui-react'
import NavBar from '../../Features/nav/NavBar'
import RequestDashboard from '../../Features/requests/list/RequestDashboard'
import RequestReview from '../../Features/requests/review/details/RequestReview'
import RequestReviews from '../../Features/requests/review/List/RequestReviewDashboard'
import RequestReviewPDF from '../../Features/requests/review/details/RequestReviewPDF'
import NoteDashboard from '../../Features/notes/list/NoteDashboard'
import { observer } from 'mobx-react-lite'
import { Route, withRouter, RouteComponentProps, Switch } from 'react-router-dom';
import HomePage from '../../Features/home/HomePage';
import NotFound from './NotFound';
import NotAuthorized from './NotAuthorized';
import { ToastContainer } from 'react-toastify';
import LoadingComponent from './LoadingComponent';
import { RootStoreContext } from '../stores/RootStore';
import ModalContainer from '../common/modals/ModalContainer';
import PrivateRoute from './PrivateRoute';
import Footer from '../../Features/Footer/Footer';
import { Worker } from '@react-pdf-viewer/core';

import RoleRules from "../enumerable/RolesRules";
import 'semantic-ui-css/semantic.min.css';
import "../../assets/scss/urdi.scss";
import AdminDashboard from '../../Features/Admin/AdminDashboard';
import Teapot from './Teapot';
import ChangelogList from "../../Features/Changelog/ChangelogList";
import {useAccount, useMsal} from "@azure/msal-react";

const App: React.FC<RouteComponentProps> = ({ location }) => {
  const rootStore = useContext(RootStoreContext);
  const { setAppLoaded, appLoaded } = rootStore.commonStore;
   const { getUser } = rootStore.userStore;
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  //const [apiData, setApiData] = useState(null);

  useEffect(() => {
    // if (account) {
    //   instance.acquireTokenSilent({
    //     scopes: ["User.Read", "offline_access"],
    //     account: account
    //   }).then((response) => {
    //     if(response) {
    //
    //       // callMsGraph(response.accessToken).then((result) => setUser(result));
    //     }
    //   });
    //
    // }
    //  setAppLoaded()
    if(account){
      getUser().finally(() => setAppLoaded())
    }
    else{
      setAppLoaded()
    }


    const script = document.createElement('script');
    //atlasian/ jira plugin
    script.src = "https://rolkaloube.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/o2joag/b/24/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=6584a13f";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }


  }, [account, instance, setAppLoaded, getUser])


  if (!appLoaded) return <LoadingComponent active={true} content='Loading app...' />
  return (
    <Worker
      workerUrl="https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.min.js"
    >
      <Fragment >
        <ModalContainer />
        <Footer />
        <div className="main-panel">

          <ToastContainer position='bottom-right' />
          <Route exact path='/' component={HomePage} />
          <Route path={'/(.+)'} render={() => (
            <Fragment >
              <NavBar />
              <Container className={"main-container"}>
                <Switch>
                  <PrivateRoute exact path='/Requests' component={RequestDashboard} Requirments={RoleRules.URDIAccess} />
                  <PrivateRoute exact path='/RequestReview/:id' component={RequestReview} Requirments={RoleRules.URDIAccess} />
                  <PrivateRoute exact path='/RequestReviews' component={RequestReviews} Requirments={RoleRules.ReviewerAdmin} />

                  <PrivateRoute exact path='/RequestReviewPDF' component={RequestReviewPDF} Requirments={RoleRules.URDIAccess} />
                  <PrivateRoute exact path='/Notes' component={NoteDashboard} Requirments={RoleRules.ReviewerAdmin} />
                  <PrivateRoute exact path='/Admin' component={AdminDashboard} Requirments={RoleRules.SystemAdmin} />
                  <PrivateRoute exact path='/Changelog' component={ChangelogList} Requirments={RoleRules.URDIAccess} />

                  <Route path='/NotFound' component={NotFound}></Route>
                  <Route path='/NotAuthorized' component={NotAuthorized}></Route>
                  <Route path='/Teapot' component={Teapot}></Route>
                </Switch>
              </Container>
            </Fragment>
          )} />
        </div>
      </Fragment>
    </Worker>
  );
};
export default withRouter(observer(App));